import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

import BarChart from '../chartjs/BarChart.vue';
import LineChart from '../chartjs/LineChart.vue';
import { Data } from '../../models';
import { ChartType } from '../../models/chartType';
import { computed, PropType, ref } from 'vue';
import { useReportData } from '@/features/reports/util/useReportData';
import Report from '@/features/reports/components/Report.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'ConversationTrendCharts',
  props: {
  data: {
    type: [Object, undefined] as PropType<Data | undefined>,
    required: false,
  },
  loadedData: {
    type: Boolean,
    default: false,
  },
  loadingError: {
    type: Boolean,
    default: false,
  },
},
  setup(__props) {

const props = __props;

const { reportId, isDataLoaded, isDataEmpty } = useReportData(props);

const chartType = ref(ChartType.BAR);

const showLineChart = computed(() => chartType.value === ChartType.LINE);
const showBarChart = computed(() => chartType.value === ChartType.BAR);

const switchBarChart = () => (chartType.value = ChartType.BAR);
const switchLineChart = () => (chartType.value = ChartType.LINE);

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createBlock(Report, {
    "report-id": _unref(reportId),
    title: "Conversations",
    "tooltip-text": "A trend showing the number of recently created conversations",
    class: "chart-container",
    dataEmpty: _unref(isDataEmpty),
    loadedData: _unref(isDataLoaded),
    loadingError: __props.loadingError
  }, {
    "header-addons": _withCtx(() => [
      _createElementVNode("span", {
        class: _normalizeClass(["button", { 'is-static': showLineChart.value }]),
        onClick: _cache[0] || (_cache[0] = ($event: any) => (switchLineChart()))
      }, [
        _createVNode(_component_font_awesome_icon, { icon: "chart-line" })
      ], 2),
      _createElementVNode("span", {
        class: _normalizeClass(["button", { 'is-static': showBarChart.value }]),
        onClick: _cache[1] || (_cache[1] = ($event: any) => (switchBarChart()))
      }, [
        _createVNode(_component_font_awesome_icon, { icon: "chart-bar" })
      ], 2)
    ]),
    chart: _withCtx(() => [
      (showLineChart.value)
        ? (_openBlock(), _createBlock(LineChart, {
            key: 0,
            reportId: _unref(reportId),
            class: "chart",
            data: __props.data,
            fill: false,
            allowDecimalTicksY: false,
            seriesOrder: ['Conversations']
          }, null, 8, ["reportId", "data"]))
        : _createCommentVNode("", true),
      (showBarChart.value)
        ? (_openBlock(), _createBlock(BarChart, {
            key: 1,
            reportId: _unref(reportId),
            class: "chart",
            data: __props.data,
            seriesOrder: ['Conversations']
          }, null, 8, ["reportId", "data"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["report-id", "dataEmpty", "loadedData", "loadingError"]))
}
}

})